import React, { useState, useEffect } from "react";
import { Stack, Switch, Select, MenuItem } from "@mui/material";
import OrgNamedList from "./OrgNamedList";
import { getDesignations, createDesignation, updateDesignation, deleteDesignation } from "../../../../../services/designation";
import { getGradeLevels } from "../../../../../services/gradeLevel";
import { getActiveLegalUnitId } from "../../../../../services/globalData";
import { tokens } from "../../../../../theme";

// per-designation default geofence exemption (e.g. field-staff roles). An
// employee's own geofence setting overrides this.
const ExemptToggle = ({ item, reload }) => (
  <Stack direction="row" alignItems="center" spacing={0.5}>
    <span style={{ fontSize: "0.8125rem", color: tokens.textMuted }}>Geofence exempt</span>
    <Switch size="small" checked={Boolean(item.geofenceExempt)}
      onChange={async (e) => { await updateDesignation(item._id, { geofenceExempt: e.target.checked }); reload(); }} />
  </Stack>
);

// default grade for this designation — selecting a designation on an employee
// suggests this grade (and its salary band).
const GradePicker = ({ item, grades, reload }) => (
  <Stack direction="row" alignItems="center" spacing={0.5}>
    <span style={{ fontSize: "0.8125rem", color: tokens.textMuted }}>Default grade</span>
    <Select size="small" displayEmpty value={item.grade || ""} sx={{ minWidth: "6rem", fontSize: "0.8125rem" }}
      onChange={async (e) => { await updateDesignation(item._id, { grade: e.target.value || null }); reload(); }}>
      <MenuItem value=""><em>—</em></MenuItem>
      {grades.map((g) => <MenuItem key={g._id} value={g._id}>{g.name}</MenuItem>)}
    </Select>
  </Stack>
);

const Designations = () => {
  const [grades, setGrades] = useState([]);
  useEffect(() => { getGradeLevels().then((r) => setGrades(Array.isArray(r?.data) ? r.data : [])).catch(() => {}); }, []);

  return (
    <OrgNamedList
      title="Designations"
      singular="Designation"
      addLabel="Add Designation"
      emptyText="Define the job titles used across your organisation."
      fetchItems={async () => {
        const res = await getDesignations();
        if (res?.success === false) throw new Error(res?.message);
        return res?.data || [];
      }}
      createItem={(name) => createDesignation({ name, legalUnit: getActiveLegalUnitId() })}
      removeItem={(item) => deleteDesignation(item._id)}
      rowExtra={(item, reload) => (
        <Stack direction="row" alignItems="center" spacing={2}>
          {grades.length > 0 && <GradePicker item={item} grades={grades} reload={reload} />}
          <ExemptToggle item={item} reload={reload} />
        </Stack>
      )}
    />
  );
};

export default Designations;
